import { render, staticRenderFns } from "./MyAdsIcon.vue?vue&type=template&id=10483c4b"
import script from "./MyAdsIcon.vue?vue&type=script&lang=js"
export * from "./MyAdsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports